"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createReducer;

var _immutable = _interopRequireDefault(require("immutable"));

var undefinedActionKey = /^undefined/;
/**
 * Create a handler (action) map reducer for the given list of handlers
 *
 * @param  {object} initialState      The initial state of the reducer, expecting an Immutable.Iterable instance,
 * otherwise given initialState is converted to immutable.
 * @param  {object} handlers          A map of actions where key is action name and value is a reducer function
 * @param  {boolean} enforceImmutable Should state be immutable
 * @return {object}                   The calculated next state
 */

function createReducer(initialState) {
  var handlers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var enforceImmutable = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  Object.keys(handlers).forEach(function (actionKey) {
    if (undefinedActionKey.test(actionKey)) {
      throw new Error('One of the reducer handler keys is "undefined". Check for an undefined action key or a typo in the action key name.');
    }
  });
  return function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments.length > 1 ? arguments[1] : undefined;
    var newState = state; // convert the initial state to immutable
    // This is useful in isomorphic apps where states were serialized

    if (enforceImmutable && !_immutable.default.Iterable.isIterable(newState)) {
      newState = _immutable.default.fromJS(newState);
    }

    var handler = action && action.type ? handlers[action.type] : undefined;
    return handler ? handler(newState, action) : newState;
  };
}

module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-app-platform/lib/common/createReducer.js
// module id = 173
// module chunks = 25